import React from 'react';
import InputEdit from 'components/common/input-edit';
import { withCollectionFieldDistinct } from 'hooks/with-collection-field-distinct';

function District(props) {
  return <InputEdit {...props} />;
}

export default withCollectionFieldDistinct(District, { collection: 'pr' });
